import { useMemo } from 'react';

// Import the game images
import huntingImage from '@/images/hunting.avif';
import motorsportImage from '@/images/motorsport_series.jpg';
import defaultImage from '@/images/NACON.png';
import sessionImage from '@/images/session.jpg';
import tduImage from '@/images/TDUSC.png';

export const useGameImage = () => {
  const gameImageMap = useMemo(() => {
    // You can fill this map with your game codes and corresponding images
    const imageMap: Record<string, string> = {
      // Example mappings - fill these with your actual game codes
      hs3: huntingImage,
      ems: motorsportImage,
      session: sessionImage,
      tdusc: tduImage,
      // Add more game code to image mappings here
    };

    return imageMap;
  }, []);

  const getGameImage = (gameCode: string): string => {
    return gameImageMap[gameCode.toLowerCase()] || defaultImage;
  };

  return { getGameImage, gameImageMap };
};
